var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    { staticClass: "custom-choice-element" },
    [
      _c(
        "input",
        _vm._b(
          {
            domProps: { checked: _vm.value },
            on: {
              input: function($event) {
                return _vm.$emit("input", $event.target.checked)
              },
              change: function($event) {
                return _vm.$emit("change", $event)
              }
            }
          },
          "input",
          _vm.$attrs,
          false
        )
      ),
      _vm._v(" "),
      _c("span", { staticClass: "image" }),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }